import { render, staticRenderFns } from "./RsaConfigurazioneAggiornamentoTariffaListPage.vue?vue&type=template&id=24a44164&scoped=true"
import script from "./RsaConfigurazioneAggiornamentoTariffaListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAggiornamentoTariffaListPage.vue?vue&type=script&lang=js"
import style0 from "./RsaConfigurazioneAggiornamentoTariffaListPage.vue?vue&type=style&index=0&id=24a44164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a44164",
  null
  
)

export default component.exports